import { Checkbox, DateString, infiltrationRateOptions, isArrayEmpty, react, wormTypeOptions } from "../../../omnia"
import { SelectableSoilAssessment } from "../../analysis/sa"
import { PlanContext } from "../../context"
import { SelectedPlanField } from "../../types"
import { Header } from "./Header"

interface Props {
    field: SelectedPlanField
}

const infiltrationRateMap = new Map(infiltrationRateOptions)
const wormTypeMap = new Map(wormTypeOptions)

export function SoilAssessmentTable({ field: { analysis: { sa } } }: Props) {

    const { dispatch } = React.useContext(PlanContext)

    if (isArrayEmpty(sa)) {
        return null
    }

    const setSelected = (analysis: SelectableSoilAssessment, selected: boolean) => {
        dispatch({ type: "selectAnalysis", target: { type: "sa", analysis }, selected })
    }

    return <Header title="Soil assessments" className="sa">

        <table className="table omnia-table">

            <thead>
                <tr>
                    <th>Date</th>
                    <th>VESS score</th>
                    <th>Worm count</th>
                    <th>Worm type</th>
                    <th>Macro fauna</th>
                    <th>Infiltration rate</th>
                    <th colSpan={3}>pH</th>
                </tr>
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th className="depth">0-5 cm</th>
                    <th className="depth">5-20 cm</th>
                    <th className="depth">&gt; 20 cm</th>
                </tr>

            </thead>

            <tbody>

                {
                    sa.map(a => <tr key={a.key}>

                        <td className="date">
                            <Checkbox checked={a.selected.value} setChecked={s => setSelected(a, s)} icons={true}>
                                {formatDate(a.sa.date)}
                            </Checkbox>
                        </td>

                        <td>{a.sa.vess}</td>
                        <td>{a.sa.wormCount}</td>
                        <td>{getLabel(wormTypeMap, a.sa.wormType)}</td>
                        <td>{a.sa.macroFauna}</td>
                        <td>{getLabel(infiltrationRateMap, a.sa.infiltrationRate)}</td>
                        <td>{a.sa.pH_0_5}</td>
                        <td>{a.sa.pH_5_20}</td>
                        <td>{a.sa.pH_5_20}</td>

                    </tr>)

                }
            </tbody>

        </table>

    </Header>

}


function formatDate(date: DateString) {
    return date ? new Date(date).toLocaleDateString() : undefined
}

function getLabel(map: Map<number, string>, a: number) {
    return a
        ? (map.get(a) ?? `#${a}`)
        : undefined
}
